import React, { useState, useEffect, useRef } from 'react';
import { Box, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, Typography } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Dropdown } from 'primereact/dropdown';
import { json, useLocation, useNavigate, useParams } from 'react-router-dom';
import getRequest, { postRequest, putRequest } from '../../../assets/helper/ApiHandler';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { ApiData } from '../../../data/apiData';
import { v4 as uuidv4 } from 'uuid';
import { convertArrayToJson, convertJsonToList } from '../../../assets/helper/helper';
import { vastSettingsJson } from '../../../assets/helper/DummyJson/VastJson';
import AddIcon from '../../../assets/images/icons/add.svg';

var routesObject = {
    name: '',
    filterExpression: '',
    jsonMerge: '',
    margin: '',
    vastSetting: '',
    qps: '',
    isEnabled: false,
    isSellerSchainRequired: '',
    isSellerSchainOverride: '',
    schain: false,
    comment: '',
    bcat: null,
    badv: '',
    maxBidFloor: '',
    supplies: '',
    demand: '',
}


var formTouchedObj = {
    name: false,
    supplies: false,
    demand: false,
    qps: false,
    margin: false,
    isSellerSchainRequired: false,
    targetingCondition: false,
    maxBidFloor: false

}

const values = [
    { id: 1, text: "Basic Information", path: "basic-information" },
    { id: 2, text: "Description", path: "description" },
    { id: 3, text: "Prefrences", path: "prefrences" },
    { id: 4, text: "Additional Configuration", path: "additional-configuration" },
    { id: 5, text: "Pretargeting", path: "pretargeting" }
];

const extractKeysFromJson = () => {
    const keys = [];
    const addKeys = (obj, parentKey = '') => {
        Object.keys(obj).forEach(key => {
            let fullKey = parentKey ? `${parentKey}.${key}` : key;
            if (fullKey.startsWith("video.")) {
                fullKey = fullKey.slice(6);
            }
            fullKey = fullKey.replace(/\(required\)/g, "");

            if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
                addKeys(obj[key], fullKey);
            } else {
                if (key !== 'id(required)' && key !== 'video' && key !== 'ext' && !(parentKey === 'ext' && key === 'rewarded')) {
                    keys.push(fullKey);
                }
            }
        });
    };
    addKeys(vastSettingsJson);
    return keys;
};


export function NewRoute() {

    const [selectedConfidential, setSelectedConfidential] = useState(null);
    const confidential = [
        { name: 'Yes', value: 'Yes' },
        { name: 'No', value: 'No' }
    ];
    const [active, setActive] = useState();

    const params = useParams();
    const navigate = useNavigate();
    const toast = useRef(null);
    const location = useLocation();
    const [routes, setRoutes] = useState(routesObject);
    const [routesFormError, setRoutesFormError] = useState(routesObject)
    const [formTouched, setFormTouched] = useState(formTouchedObj);
    const [title, setTitle] = useState('');
    const formMode = params.id ? 'Edit' : "Create";
    const isEditMode = params.id ? true : false;
    const [supplies, setSupplies] = useState([]);
    const [demands, setDemands] = useState([])
    const [bct, setBcat] = useState([]);
    const selectedDemand = demands.find(demand => demand.id === routes.demand.id);
    const labelNames = bct.map(obj => obj.label);
    const { id } = useParams();
    const [vastSettings, setVastSettings] = useState([]);
    const [selectedKey, setSelectedKey] = useState('');
    const keysList = extractKeysFromJson();
    const [vastKeyList, setVastKeyList] = useState(keysList);
    const [inputValue, setInputValue] = useState('');
    const [rows, setRows] = useState([{ selectedKey: '', inputValue: '' }]);


    useEffect(() => {
        contentTaxonomies();
        getSupply();
        getDemands();
        // ApiData.getSupply().then(data => setSupplies(data));
        if (params.id) {
            getRoutes();
        }
    }, [params.id], []);


    useEffect(() => {
        filterAlreadyAddedKeys();
    }, [vastSettings])

    useEffect(() => {
        if (Object.values(formTouched).some((touched) => touched === true)) {
            validateFormData();
        }
    }, [routes, formTouched]);


    const getRoutes = async () => {
        try {
            const routesData = await getRequest(`/supply-to-demand-filters/${params.id}`);
            setRoutes({
                ...routesData,
                bcat: routesData.bcat ? routesData.bcat.split(',').map(item => item.trim()) : []
            });

            setVastSettings(convertJsonToList(routesData?.vastSetting))

        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };
    const contentTaxonomies = async () => {
        try {
            const contentTaxonomiesData = await getRequest(`/content-taxonomies`);
            const modifiedData = contentTaxonomiesData.map(item => ({
                ...item,
                label: `${item.code} - ${item.cat}`,
                value: item.code
            }));

            setBcat(modifiedData);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const getSupply = async () => {
        try {
            const supplyData = await getRequest(`/supplies`);
            setSupplies(supplyData);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const getDemands = async () => {
        try {
            const demandData = await getRequest(`/demands`);
            setDemands(demandData);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };


    const handleCancel = () => {
        navigate('/routes');
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setRoutes({
            ...routes,
            [id]: value
        });
        setFormTouched({
            ...formTouched,
            [id]: true,
        });
    };


    const handleSupplyChange = (e) => {
        const selectedSupply = e.value;
        setRoutes({
            ...routes,
            supplies: selectedSupply
        });

        setFormTouched({
            ...formTouched,
            supplies: true,
        });
    };

    const handleDemandChange = (e) => {
        const selectedDemand = e.value;
        setRoutes({
            ...routes,
            demand: selectedDemand
        });

        setFormTouched({
            ...formTouched,
            demand: true,
        });
    };

    const handleBcatChange = (e) => {
        const selected = e.value;
        setRoutes({
            ...routes,
            bcat: selected || []
        });

        setFormTouched({
            ...formTouched,
            selected: true,
        });
    };

    const handleKeyChange = (e) => {
        if (e.target.id === "key") {
            setSelectedKey(e.value);
        }
        if (e.target.id === "value") {
            setInputValue(e.target.value)
        }
    };
    const handleRemoveVastSetting = (item) => {
        const updatedVastSettings = vastSettings.filter(setting => setting.id !== item.id);
        setVastSettings(updatedVastSettings);
        setVastKeyList(prevList => [...prevList, item.key]);
        setSelectedKey(item.key);
        setInputValue(item.value);
        setTimeout(() => {
            setSelectedKey(null);
            setInputValue('');
        }, 0);
    };

    const handleVastSettingValues = (e, item) => {
        let list = [...vastSettings];
        switch (e.target.id) {
            case "key":
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === item.id) {
                        list[i].key = e.target.value;
                        break;
                    }
                }
                break;
            case "value":
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === item.id) {
                        list[i].value = e.target.value;
                        break;
                    }
                }

            default:
                break;
        }
        setVastSettings(list);
    }

    const addnewRowToVastSettings = () => {
        let list = [...vastSettings];
        list.push({ id: uuidv4(), key: selectedKey, value: inputValue })
        setVastSettings(list);
        setSelectedKey("");
        setInputValue("");
    }

    const filterAlreadyAddedKeys = () => {
        let keyArray = [...vastKeyList];
        const keysSet = new Set(vastSettings.map(obj => obj.key));
        const filteredStrings = keyArray.filter(str => !keysSet.has(str));
        setVastKeyList(filteredStrings)
    }

    const handleOnSubmit = () => {
        let { name: bcat } = routes;

        const bcatArray = Array.isArray(bcat) ? bcat : [];

        const bcatString = bcatArray.map(item => item.split(' ')[0]).join(',');
        if (validateFormData()) {
            const payload = {
                ...routes,
                bcat: bcatString,
                vastSetting: convertArrayToJson(vastSettings)
            };
            if (isEditMode) {
                updatedRoutes(payload);
            } else {
                saveRoutes(payload);
            }
        }
        else {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: "Check all required field " });
            }
        }
    }
    const saveRoutes = async (payload) => {
        try {
            let res = await postRequest('/supply-to-demand-filters', payload, navigate);
            if (toast.current) {
                toast.current.show({ severity: "success", summary: 'Success', detail: "Routes  Created! " });
            }
            setTimeout(() => { navigate('/routes') }, 1000);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    }

    const updatedRoutes = async (payload) => {
        try {
            let res = await putRequest(`/supply-to-demand-filters/${params.id}`, payload, navigate);
            if (toast.current) {
                toast.current.show({ severity: "success", summary: 'Success', detail: "Routes  updated! " });
            }
            setTimeout(() => { navigate('/routes') }, 1000);
        } catch (error) {
            if (toast.current) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    }

    const validateFormData = () => {
        let errors = {};
        let flag = false;
        if (!routes.name) {
            errors.name = 'Routes is required!';
        }
        if (routes.supplies.length === 0) {
            errors.supplies = "Supplies is required!"
        }
        if (!routes.demand) {
            errors.demand = "Demand is required!"
        }
        if (!routes.qps) {
            errors.qps = "QPS is required!"
        }
        if (!routes.margin || routes.margin < -50 || routes.margin > 99) {
            errors.margin = 'Margin  is required! & must be between -50 and 99 ';
        }
        if (routes.isSellerSchainRequired === "") {
            errors.isSellerSchainRequired = "Schain is required!"
        }
        setRoutesFormError(errors);
        if (Object.keys(errors).length === 0) {
            flag = true;
        }
        return flag;
    };

    const addRow = () => {
        setRows([...rows, { selectedKey: '', inputValue: '' }]);
    };

    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Box className='main-content-header header-bottom-line'>
                <h2>{formMode + " Routes"}</h2>
            </Box>
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <Box className='content-sticky-top'>
                            <List className='list-page-link'>
                                {values.map((val) => (
                                    <ListItem key={val.id} className='fs-2' onClick={() => setActive(val.id)}>
                                        <a href={'#' + val.path} style={{ textDecoration: 'none' }} className={active === val.id ? "active" : ""}>{val.text}</a>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Grid>
                    <Grid item xs={9} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                        <Box className="card omega-forms">
                            <Box id="basic-information" sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Basic Information</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Route Name *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the name of the route</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="name"
                                            placeholder=""
                                            className={routesFormError.name ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={routes?.name ?? ''}
                                            onChange={handleInputChange}
                                            onBlur={() => setFormTouched({ ...formTouched, name: true })}

                                        />
                                        {routesFormError.name && (
                                            <Typography level="title-sm" className="error-message fs-2">{routesFormError.name||''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'> Select Supply *</Typography>
                                        <Typography level="body-xs" className='fs-3'>Select the  supply </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <MultiSelect
                                            value={routes?.supplies ?? ''}
                                            filter
                                            display='chip'
                                            className={routesFormError.supplies ? 'mr-2 p-invalid' : 'mr-2'}
                                            // maxSelectedLabels={3}
                                            onChange={handleSupplyChange}
                                            options={supplies}
                                            optionLabel="name" />
                                        {routesFormError.supplies && (
                                            <Typography level="title-sm" className="error-message fs-2">{routesFormError.supplies||''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Select Demand *</Typography>
                                        <Typography level="body-xs" className='fs-3'>Select the demand  </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown
                                            value={selectedDemand??''}
                                            filter
                                            className={routesFormError.demand ? 'mr-2 p-invalid' : 'mr-2'}
                                            onChange={handleDemandChange}
                                            options={demands}
                                            optionLabel="name"
                                        />
                                        {routesFormError.demand && (
                                            <Typography level="title-sm" className="error-message fs-2">{routesFormError.demand||''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-top form-group-border-bottom">
                                <Box id="description" sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Description</Typography>
                                </Box>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Route  Description</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter a description for Route</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="comment"
                                            value={routes?.comment ?? ''}
                                            placeholder=""
                                            className="mr-2"
                                            onChange={handleInputChange} />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                <Box id="prefrences" sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography level="title-sm" className='fs-1'>Prefrences</Typography>
                                </Box>
                                {/* <Grid container spacing={2}>
                           <Grid item xs={4}>
                              <Typography level="title-sm" className='fs-2'>Max Bid Floor *</Typography>
                              <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the maximum bid to pass in the request</Typography>
                           </Grid>
                           <Grid item xs={8}>
                              <InputText id="max-bid-floor" placeholder="" className="mr-2" />
                           </Grid>
                        </Grid> */}
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>QPS *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the qps of the request   </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="qps"
                                            placeholder=""
                                            className={routesFormError.qps ? 'mr-2 p-invalid' : 'mr-2'}
                                            value={routes?.qps ?? ''}
                                            onChange={handleInputChange}
                                        />
                                        {routesFormError.qps && (
                                            <Typography level="title-sm" className="error-message fs-2">{routesFormError.qps||''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Supply Margin *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the supply margin</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="margin"
                                            className={routesFormError.margin ? 'mr-2 p-invalid' : 'mr-2'}
                                            type='number'
                                            value={routes?.margin ?? ''}
                                            onChange={handleInputChange}
                                            onBlur={() => setFormTouched({ ...formTouched, margin: true })}
                                        />
                                        {routesFormError.margin && (
                                            <Typography level="title-sm" className="error-message fs-2">{routesFormError.margin||''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Schain Required? *</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Select if schain is required</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown value={routes ? routes.isSellerSchainRequired : false}
                                            className={routesFormError.isSellerSchainRequired ? 'mr-2 p-invalid' : 'mr-2'}
                                            onChange={(e) => {
                                                setRoutes({ ...routes, isSellerSchainRequired: e.value === true });
                                                setRoutesFormError({ ...routesFormError, isSellerSchainRequired: false });
                                            }} options={[
                                                { name: 'Yes', value: true },
                                                { name: 'No', value: false }
                                            ]}
                                            optionLabel="name" >
                                        </Dropdown>
                                        {routesFormError.isSellerSchainRequired && (
                                            <Typography level="title-sm" className="error-message fs-2">{routesFormError.isSellerSchainRequired||''}</Typography>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Schain Override</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Select if schain needs to be overridden</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Dropdown value={routes ? routes.isSellerSchainOverride : false}
                                            onChange={(e) => setRoutes({ ...routes, isSellerSchainOverride: e.value === true })}
                                            options={[
                                                { name: 'Yes', value: true },
                                                { name: 'No', value: false }
                                            ]}
                                            optionLabel="name" >

                                        </Dropdown>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Schain </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter schain if it needs to be overridden</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="schain"
                                            placeholder=""
                                            className="mr-2"
                                            value={routes?.schain ?? ''}
                                            onChange={handleInputChange} />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Blocked IAB Categories </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Select IAB categories to block</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <MultiSelect
                                            filter
                                            maxSelectedLabels={3}
                                            display='chip'
                                            value={routes?.bcat ?? ''}
                                            onChange={handleBcatChange}
                                            options={bct}
                                            optionLabel="label" />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Blocked Advertiser Domain </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Select advertiser domain to block</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="badv"
                                            placeholder=""
                                            className="mr-2"
                                            value={routes?.badv ?? ''}
                                            onChange={handleInputChange} />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography id="additional-configuration" level="title-sm" className='fs-1'>Additional Configuration </Typography>
                                </Box>
                                {/* <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>VAST Settings  </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the json to override vast request  </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText id="vastSetting"
                                            placeholder=""
                                            className="mr-2"
                                            value={routes ? routes.vastSetting : ''}
                                            onChange={handleInputChange} />
                                    </Grid>
                                </Grid> */}

                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>VAST Settings</Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="demand">Enter the json to override vast request</Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        {vastSettings.map(item => {
                                            return <div style={{ margin: '5px 0' }}>
                                                <Grid key={item.id} sx={{ gap: 1, flexGrow: 1, display: 'flex' }}>
                                                    <InputText
                                                        id="key"
                                                        value={item.key || ''}
                                                        disabled
                                                        onChange={(e) => handleVastSettingValues(e, item)}
                                                        className="mr-2 auto-width h-30" />

                                                    <InputText
                                                        id="value"
                                                        value={typeof item.value === 'object' ? JSON.stringify(item.value) : (item.value || '')}
                                                        onChange={(e) => handleVastSettingValues(e, item)}
                                                        //className="mr-2 auto-width h-30" 
                                                        className={item.value === "" ? 'mr-2 auto-width h-30 p-invalid' : 'mr-2 auto-width h-30'}
                                                    />
                                                    <Button type="button" className='remove-icon-btn' onClick={() => handleRemoveVastSetting(item)}>
                                                        <Image src={AddIcon} alt="Image" width="24" /></Button>
                                                </Grid>
                                            </div>
                                        })
                                        }
                                        {/* <Button variant="contained" className="button-style-2 button-plus" style={{ margin: '5px 0' }}
                                            onClick={addnewRowToVastSettings}
                                        >+</Button> */}

                                        {/* <div className='parameter-row additional-row'> */}
                                        {/* <Grid item xs={8} sx={{ gap: 1, flexGrow: 1, display: 'flex' }} className='vast-settings'> */}
                                        <Grid item sx={{ gap: 1 }} style={{ margin: '5px 0', display: 'flex' }}>
                                            <Grid item xs={8} style={{ minWidth: '50%', maxWidth: '50%' }} className='flex'>
                                                <Dropdown
                                                    value={selectedKey??''}
                                                    placeholder='Select Vast Setting...'
                                                    id="key"
                                                    onChange={handleKeyChange}
                                                    options={vastKeyList}
                                                    className="mr-2 h-30 vast-setting-dropdown"
                                                />
                                            </Grid>
                                            <Grid item xs={4} style={{ minWidth: '50%', maxWidth: '50%', paddingRight: '8px' }} className='flex'>
                                                <InputText
                                                    className="mr-2 h-30 vast-setting-inputtext"
                                                    id="value"
                                                    value={inputValue}
                                                    onChange={(e) => {
                                                        handleKeyChange(e)
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        {/* </Grid> */}
                                        {/* </div> */}
                                        <Grid sx={{ gap: 1, flexGrow: 1 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                                {/* <Button variant="contained" className="button-style-2 button-plus" style={{ margin: '5px 0' }}
                                                    onClick={addnewRowToVastSettings}>+</Button> */}
                                                <Button type="button" className='add-icon-btn' style={{ margin: '5px 0' }} onClick={addnewRowToVastSettings}><Image src={AddIcon} alt="Image" width="24" /></Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>JSON Merge </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Enter the name of the supply partner </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <InputText
                                            id="jsonMerge"
                                            placeholder=""
                                            className="mr-2"
                                            value={routes?.jsonMerge ?? ''}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* added here pretargeting  */}
                            <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                <Box sx={{ minWidth: 0, flex: 1 }}>
                                    <Typography id="pretargeting" level="title-sm" className='fs-1'>Pretargeting </Typography>
                                </Box>
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Typography level="title-sm" className='fs-2'>Targeting Condition  * </Typography>
                                        <Typography level="body-xs" className='fs-3' htmlFor="supply-partner-name">Select and configure the targeting condition   </Typography>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <div></div>
                                        <Grid sx={{ gap: 1, flexGrow: 1, display: 'flex' }}>
                                            <Dropdown value={selectedConfidential} onChange={(e) => setSelectedConfidential(e.value)} options={confidential} optionLabel="name" className="auto-width h-30" />
                                            <Dropdown value={selectedConfidential} onChange={(e) => setSelectedConfidential(e.value)} options={confidential} optionLabel="name" className="auto-width h-30" />
                                            <InputText id="" placeholder="" className="mr-2 auto-width h-30" />
                                            <InputText id="" placeholder="" className="mr-2 auto-width h-30" />
                                        </Grid>
                                        <Grid sx={{ gap: 1, flexGrow: 1 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                                <Button variant="contained" className="button-style-2 button-plus" style={{ margin: '5px 0' }}>+</Button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                            {isEditMode && (
                                <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }} className="form-group-border-bottom">
                                    <Box sx={{ minWidth: 0, flex: 1 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <Typography level="title-sm" className='fs-2'>Status</Typography>
                                                <Typography level="body-xs" className='fs-3' htmlFor="demand">Select the status of the routes  </Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Dropdown
                                                    value={routes && routes.isEnabled ? routes.isEnabled : false}
                                                    onChange={(e) => setRoutes({ ...routes, isEnabled: e.value === true })}
                                                    options={[
                                                        { name: 'Active', value: true },
                                                        { name: 'Stopped', value: false }
                                                    ]}
                                                    optionLabel="name" />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                            )}
                            <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                                <Button type="button" className="button-style-2" label="Cancel" size="small" onClick={handleCancel}></Button>
                                <Button type="button" className="button-style-1" label="Update" size="small" onClick={handleOnSubmit}></Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};

export default NewRoute;

